import React, { useState, useEffect } from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/Global/layout";
// import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image"
import NewsInsightsListingCards from "../components/NewsInsightsListing/NewsInsightsListingCards";
import SpotlightDetail from "../components/Global/spotlightDetail";
// import newsListSpotlightBanner from "../common/images/NewsInsightsList/newsListSpotlightBanner.png";
import newsListSpotlightClip from "../common/images/NewsInsightsList/newsListSpotlightClip.png";
// import searchArrowWhite from "../common/images/NewsInsightsList/searchArrowWhite.svg";
// import newsCalender from "../common/images/NewsInsightsList/newsCalender.svg";
// import paginationLeftArrow from "../common/images/NewsInsightsList/paginationLeftArrow.svg";
// import paginationRightArrow from "../common/images/NewsInsightsList/paginationRightArrow.svg";
// import newsListBrandMatrix from "../common/images/NewsInsightsList/newsListBrandMatrix.svg";
import newsAndInsightsPattern from "../common/images/Homepage/newsAndInsights/newsAndInsightsPattern.png";
import bxFilter from "../common/images/NewsInsightsList/bx_filter-alt.png";
import filterSearch from "../common/images/NewsInsightsList/fluent_search.png";
import mediaClose from "../common/images/NewsInsightsList/media-close-btn.png";
import mediaCloseMobile from "../common/images/NewsInsightsList/media-close-icon-mobile.png";
// import rightArrowWhite from "../common/images/Homepage/whatWeDo/rightArrowWhite.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import SiteTrans from "../components/LangConfig/siteTrans.json";
import { transDate } from '../components/services/generic';
import BreadcrumbSchema from "../components/BreadcrumbSchema";

const NewsListing = (props) => {
  const currentPage = props.data.wpPage;

  const spotlightDetail = currentPage.spotlightDetail;
  const featuredSize = 3;
  const pageSize = 6;
  const [paginateCount, setPaginateCount] = useState(1);
  const [showLoadMore, setShowLoadMore] = useState(true);

  let allPosts;
  useEffect(() => {
    if (process.env.GATSBY_PREVIEW_MODE === "true") {
      allPosts = props.data.allWpNews.edges;
    } else {
      allPosts = props.data.allWpNews.edges.filter(news => news.node.publishStatus.status !== 'private')
      // allPosts = props.data.allWpNews.edges;
    }
  })

  const translateDate = (enmonth,lang) => {
    var trans =  transDate(enmonth,lang);
    return trans;
}

  // var allPosts = props.data.allWpNews.edges;
  // const [fullPosts, setFullPosts] = useState(allPosts);

  const [fixedfeaturedPosts, setFixedFeaturedPosts] = useState([]);
  const [fixedNonFeaturedPosts, setFixedNonFeaturedPosts] = useState([]);

  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [nonFeaturedPosts, setNonFeaturedPosts] = useState([]);

  const [visibleNews, setVisibleNews] = useState([]);
  const [sortbyvalue, setSortbyvalue] = useState("");
  const [isAboveRefPoint, setIsAboveRefPoint] = useState(true);

  const headerListenToScroll = () => {
    const newsInsightsSectionPosition = document.getElementById(
      "spotlight-detail-title-ref"
    )?.offsetTop;
    const scrollPosition = window.scrollY;

    if (scrollPosition < newsInsightsSectionPosition) {
      setIsAboveRefPoint(true);
    } else {
      setIsAboveRefPoint(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", headerListenToScroll);
    return () => {
      window.removeEventListener("scroll", headerListenToScroll);
    };
  }, []);

  /* ******** Fetching Main Data Start ******** */
  // let featuredNews = [];
  // let allNonFeaturedPostsByDate = [];

  useEffect(() => {
    let featuredCatagoryOne = allPosts
      .filter((item) => item.node.press_release_acf.featured === true)
      .slice(0, featuredSize);
    // featuredNews = featuredCatagoryOne;
    setFeaturedPosts(featuredCatagoryOne);
    setFixedFeaturedPosts(featuredCatagoryOne);

    const nonFeaturedCatagoryOne = allPosts.filter((item1) => {
      const idToMatch = item1.node.id;
      return !featuredCatagoryOne.some((item) => item.node.id === idToMatch);
    });
    let allNonFeaturedPosts = nonFeaturedCatagoryOne;

    // allNonFeaturedPostsByDate = allNonFeaturedPosts.sort(function (a, b) {
    //   return new Date(b.node.date) - new Date(a.node.date)
    // });
    // allNonFeaturedPostsByDate = allNonFeaturedPosts
    setNonFeaturedPosts(allNonFeaturedPosts);
    setFixedNonFeaturedPosts(allNonFeaturedPosts);
  }, [allPosts]);

  /* ********Fetching Main Data End ******** */

  const triggerScroll = () => {
    document.getElementById("news-list-content-ref")?.scrollIntoView();
  };

  /* ******** Loadmore Pagination Start ******** */
  useEffect(() => {
    setVisibleNews(nonFeaturedPosts && nonFeaturedPosts.slice(0, 1 * pageSize));
    if (nonFeaturedPosts.length > pageSize) {
      setShowLoadMore(true);
    } else {
      setShowLoadMore(false);
    }
  }, [nonFeaturedPosts]);

  const loadMoreNews = () => {
    let newPage = paginateCount + 1;
    setPaginateCount(paginateCount + 1);
    setVisibleNews(
      nonFeaturedPosts && nonFeaturedPosts.slice(0, newPage * pageSize)
    );
  };

  useEffect(() => {
    if (paginateCount * pageSize >= nonFeaturedPosts.length) {
      setShowLoadMore(false);
    } else {
      setShowLoadMore(true);
    }
  }, [paginateCount, nonFeaturedPosts]);

  /* ******** Loadmore Pagination End ******** */

  /* ******** Filter Part Start ******** */
  // const [false, setDateFilterShow] = useState(false);
  const [mobileDateFilterShow, setMobileDateFilterShow] = useState(false);

  // const handleDateToggle = () => {
  //   setDateFilterShow(!false)
  // }
  const handleMobileDateToggle = () => {
    setMobileDateFilterShow(!mobileDateFilterShow);
  };
  const handleCloseMobilePopUp = () => {
    setMobileDateFilterShow(!mobileDateFilterShow);
    clearSearch();
  };



  // const [anyDayActive, setAnyDayActive] = useState(false)
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [dateFilterData, setDateFilterData] = useState({
    startdate: null,
    enddate: null,
    alltime: false,
  });
  const [searchKeyword, setSearchKeyword] = useState("");

  const onFormSubmit = (e) => {
    e.preventDefault();
    startSearch();
  };

  const startSearch = () => {
    filterPosts();
  };

  const getDays = (e) => {
    if (e.target.value === "all") {
      dateFilter(null, null, true);
    } else if (e.target.value === "thismonth") {
      const startDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      );
      const endDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      );
      dateFilter(startDate, endDate);
    } else if (e.target.value === "lastmonth") {
      const startDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1
      );
      const endDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        0
      );
      dateFilter(startDate, endDate);
    } else {
      const startDate = new Date(
        new Date().getTime() - e.target.value * 24 * 60 * 60 * 1000
      );
      const endDate = new Date();
      dateFilter(startDate, endDate);
    }
    setDateRange([null, null]);
  };

  const getDateRangeFilter = (date) => {
    if (date[0] !== null && date[1] !== null) {
      dateFilter(
        new Date(date[0].toDateString()),
        new Date(date[1].toDateString())
      );
      if (document.querySelector('input[name="days"]:checked') !== null) {
        document.querySelector('input[name="days"]:checked').checked = false;
      }
    } else if (date[0] === null && date[1] === null) {
      dateFilter(null, null, true);
    }
  };

  const dateFilter = (startDate, endDate, alltime = false) => {
    setDateFilterData((prevState) => ({
      ...prevState,
      startdate: startDate,
      enddate: endDate,
      alltime: alltime,
    }));
  };

  useEffect(() => {
    if (dateFilterData.startdate !== null && dateFilterData.enddate !== null) {
      filterPosts();
    }
    if (dateFilterData.alltime === true) {
      filterPosts();
    }
  }, [dateFilterData]);

  const filterPosts = () => {
    // var filteredData = fullPosts;
    var filteredData = allPosts;

    if (searchKeyword !== "") {
      filteredData = filteredData.filter((item) => {
        return Object.values(item.node.press_release_acf.shortTitle)
          .join("")
          .toLowerCase()
          .includes(searchKeyword.toLowerCase());
      });
    }
    if (dateFilterData.startdate !== null && dateFilterData.enddate !== null) {
      filteredData = filteredData.filter((news) => {
        const datepubObject = getFormatDate(
          news.node.press_release_acf.publishedDate
        );
        return (
          datepubObject >= dateFilterData.startdate &&
          datepubObject <= dateFilterData.enddate
        );
      });
    }

    if (
      searchKeyword === "" &&
      dateFilterData.startdate === null &&
      dateFilterData.enddate === null &&
      dateFilterData.alltime === false
    ) {
      setFeaturedPosts(fixedfeaturedPosts);
    } else {
      setFeaturedPosts([]);
    }

    setNonFeaturedPosts(filteredData);

    setPaginateCount(1);

    setSortbyvalue("");
  };

  const clearSearch = () => {
    setFeaturedPosts(fixedfeaturedPosts);
    setNonFeaturedPosts(fixedNonFeaturedPosts);

    setDateRange([null, null]);

    setSearchKeyword("");
    if (document.querySelector('input[name="days"]:checked') !== null) {
      document.querySelector('input[name="days"]:checked').checked = false;
    }
    //document.getElementById('anyTime').checked = true;

    setDateFilterData((prevState) => ({
      ...prevState,
      startdate: null,
      enddate: null,
      alltime: false,
    }));

    // showAllFilter();
    setSortbyvalue("");
    setPaginateCount(1);
  };

  /* ******** Filter Part End ******** */

  const getFormatDate = (date) => {
    const rawpubDate = date;
    const formattedpubDate = `${rawpubDate.slice(0, 4)}-${rawpubDate.slice(
      4,
      6
    )}-${rawpubDate.slice(6, 8)}`;
    const datepubObject = new Date(formattedpubDate);
    return datepubObject;
  };

  /* ******** Sort Start ******** */
  const handleSortBy = async (e) => {
    setSortbyvalue(e.target.value);

    var nonFeatured = nonFeaturedPosts;

    if (e.target.value === "oldest") {
      nonFeatured = nonFeatured.sort(function (b, a) {
        const bdate = getFormatDate(b.node.press_release_acf.publishedDate);
        const adate = getFormatDate(a.node.press_release_acf.publishedDate);
        return bdate - adate;
      });
    } else {
      nonFeatured = nonFeatured.sort(function (a, b) {
        const bdate = getFormatDate(b.node.press_release_acf.publishedDate);
        const adate = getFormatDate(a.node.press_release_acf.publishedDate);
        return bdate - adate;
      });
    }

    //setNonFeaturedPosts(nonFeatured);
    setVisibleNews(nonFeatured && nonFeatured.slice(0, 1 * pageSize));
    setPaginateCount(1);
    // setShowLoadMore(true)
  };
  /* ******** Sort End ******** */

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button className="customInput" onClick={onClick} ref={ref}>
      {value ? value : SiteTrans.select_dates_txt[currentPage.locale.id]}
    </button>
  ));
  const isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "active-link" } : {};
  };

  const links = {
    tabLink: [
      { label: SiteTrans.news_heading[currentPage.locale.id], route: SiteTrans.news_link[currentPage.locale.id] },
      { label: SiteTrans.insights_title[currentPage.locale.id], route: SiteTrans.insights_link[currentPage.locale.id] },
      {
        label: SiteTrans.quick_reads_heading[currentPage.locale.id],
        route: SiteTrans.quick_reads_link[currentPage.locale.id],
      },
      { label: SiteTrans.in_the_news[currentPage.locale.id], route: SiteTrans.in_the_news_link[currentPage.locale.id] },
    ],
    routeActive: isActive,
  };

  const publishedTranslatedLinks = currentPage.translated.filter(translation =>
    translation.locale.id === 'en_US' &&
    translation.localizedWpmlUrl && 
    translation.publishStatus.status !== 'private'
  );

  console.log(publishedTranslatedLinks,"publishedTranslatedLinks");
  const link = currentPage.link // Original link
  const translatedLink = publishedTranslatedLinks.length > 0 ? publishedTranslatedLinks[0].localizedWpmlUrl : currentPage.localizedWpmlUrl;
  const segments = link.split('/'); // Split the link by slashes
  const translatedsegments = translatedLink.split('/'); 
  const modifiedLink = segments.filter(segment => segment !== 'home').join('/'); // Remove "home" and join the segments
  const translatedmodifiedLink = translatedsegments.filter(segment => segment !== 'home').join('/'); 
  const contactpagelink = currentPage.locale.id === 'en_US' ? 'en' : currentPage.locale.id === 'ar' ? 'ar' : 'zh-hans'
  return (
    <Layout
      lang={currentPage.locale.id}
      translations={currentPage.translated}
      title={
        currentPage.seo.opengraphTitle ? currentPage.seo.opengraphTitle : null
      }
      description={
        currentPage.seo.opengraphDescription
          ? currentPage.seo.opengraphDescription
          : null
      }
      image={
        currentPage.featuredImage.node.sourceUrl
          ? currentPage.featuredImage.node.sourceUrl
          : null
      }
      isAboveRefPoint={isAboveRefPoint}
      translateURL={translatedmodifiedLink}
      langURL={modifiedLink}
      currentPage={currentPage}
      pageUrl={currentPage.link}
      pageId={currentPage.locale.id}
    >
      
      <BreadcrumbSchema
                    PageTitle={currentPage.title}
                    defaultPageName={"Home"}
                    pageUrl={"https://jameelmotors.com"+currentPage.link}
                    langUrl={"https://jameelmotors.com/"+contactpagelink}
                />

      <div className="news-insights-NewsListing">
        <SpotlightDetail
          spotlightDetail={spotlightDetail}
          clipImage={newsListSpotlightClip}
          image={
            currentPage.featuredImage
              ? currentPage.featuredImage.node
              : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-spotlight.png"
          }
          triggerScroll={triggerScroll}
          // links={links}
          title={currentPage.title}
          description=""
          lang={currentPage.locale.id}
        />
        <div id="news-list-content-ref" className="journey-of-motion-ref"></div>

        <div className=" position-relative">
          <div className="container position-relative z-2">
            <div className="news-insights-list-tabs-wrapper row row-cols-auto justify-content-start flex-md-row flex-column gap-md-0 gap-3">
              {links.tabLink.map((linkElements, index) => {
                return (
                  <span key={index}>
                    <Link getProps={links.routeActive} to={linkElements.route}>
                      <div className="link-active news-nav-links text-center">
                        {linkElements.label}
                      </div>
                    </Link>
                  </span>
                );
              })}
            </div>
          </div>
        </div>

        <div className="customPageContainer  terms-and-conditions-content">
          <div
            className="customPageWrapper"
            dangerouslySetInnerHTML={{
              __html: currentPage.content,
            }}
          />
        </div>

        {/* FILTER BOX START */}
        <div className="mediaCenterFilterSectionWrapper">
          <div className="media-center-wrapper-left-bg">
            <div className="container d-flex justify-content-center ">
              <div className="media-center-main-wrapper">
                <div className="mediaCenterSearchWrapper">
                  <div className="d-none d-md-block">
                    <div className="row d-flex justify-content-start g-0 align-items-center">
                      <div className="col-8">
                        <form
                          onSubmit={onFormSubmit}
                          style={{ height: "100%" }}
                        >
                          <input
                            type="text"
                            className="media-filter-select-date-input form-control"
                            name="text"
                            value={searchKeyword}
                            placeholder={SiteTrans.search_for_an_article[currentPage.locale.id]}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                          />
                        </form>
                      </div>
                      <div className="col-auto">
                        <button
                          className="media-filter-go-btn btn btn-primary"
                          onClick={startSearch}
                        >
                          {SiteTrans.search_txt[currentPage.locale.id]}
                        </button>
                      </div>
                      <div className="col-auto">
                        <button
                          className="media-filter-clear-btn btn btn-secondary"
                          onClick={clearSearch}
                        >
                          {SiteTrans.clear_all_txt[currentPage.locale.id]}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="d-block d-md-none">
                    <div className="filter-search-wrapper-mobile">
                      <div className="filter-left">
                        <button
                          className="media-filter-select-date-mobile"
                          onClick={handleMobileDateToggle}
                        >
                          <img src={bxFilter} alt="filter" />
                        </button>
                      </div>
                      <div className="filter-center">
                        <form
                          onSubmit={onFormSubmit}
                          style={{ height: "100%" }}
                        >
                          <input
                            type="text"
                            className="media-filter-select-date-input"
                            name="text"
                            value={searchKeyword}
                            placeholder={SiteTrans.search_txt[currentPage.locale.id]}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                          />
                        </form>
                      </div>
                      <div className="filter-right">
                        <button
                          className="media-filter-go-btn media-filter-go-btn-mobile"
                          onClick={startSearch}
                        >
                          <img src={filterSearch} alt="filter" />
                        </button>
                      </div>
                    </div>
                    <div className="row filterTagsWrapperMobile justify-content-end">
                      <button
                        className="media-filter-clear-btn-mobile"
                        onClick={clearSearch}
                      >
                        <img src={mediaClose} alt="clear" /> {SiteTrans.clear_all_txt[currentPage.locale.id]}
                      </button>


                    </div>
                  </div>
                </div>
                <div className="d-none d-md-block mobilePopUpSection">
                  <div
                    className={`dateFilterWrapper pt-3 ${false ? "show" : "hide"
                      }`}
                  >
                    <div className="mediaCenterDaysWrapper">
                      <div className="col-md-12" onChange={getDays}>
                        <div className="row d-flex justify-content-start align-items-center g-3">
                          <div className="col-auto">
                            <DatePicker
                              maxDate={new Date()}
                              placeholderText={SiteTrans.select_dates_txt[currentPage.locale.id]}
                              selectsRange={true}
                              startDate={startDate}
                              endDate={endDate}
                              onChange={(update) => {
                                setDateRange(update);
                                getDateRangeFilter(update);
                              }}
                              isClearable={true}
                              calendarClassName="mediaCenterDatePicker"
                              customInput={<CustomInput />}
                              showMonthDropdown
                            />
                          </div>
                          <div className="col-auto">
                            <input
                              type="radio"
                              id="anyTimedesktop"
                              value="all"
                              className="option-input radio mediaDateRange radio-custom"
                              name="days"
                            />
                            <label
                              htmlFor="anyTimedesktop"
                              className="radio-custom-label"
                            >
                              {SiteTrans.any_time_txt[currentPage.locale.id]}
                            </label>
                          </div>
                          <div className="col-auto">
                            <input
                              type="radio"
                              id="thismonthdesktop"
                              value="thismonth"
                              className="option-input radio mediaDateRange radio-custom"
                              name="days"
                            />
                            <label
                              htmlFor="thismonthdesktop"
                              className="radio-custom-label"
                            >
                              {SiteTrans.this_month_txt[currentPage.locale.id]}
                            </label>
                          </div>
                          <div className="col-auto">
                            <input
                              type="radio"
                              id="lastmonthdesktop"
                              value="lastmonth"
                              className="option-input radio mediaDateRange radio-custom"
                              name="days"
                            />
                            <label
                              htmlFor="lastmonthdesktop"
                              className="radio-custom-label"
                            >
                             {SiteTrans.last_month_txt[currentPage.locale.id]}
                            </label>
                          </div>
                          <div className="col-auto">
                            <input
                              type="radio"
                              id="lastdaysdesktop"
                              value="30"
                              className="option-input radio mediaDateRange radio-custom"
                              name="days"
                            />
                            <label
                              htmlFor="lastdaysdesktop"
                              className="radio-custom-label"
                            >
                              {SiteTrans.last_30_days_txt[currentPage.locale.id]}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`mobilePopUpSectionWrapper ${mobileDateFilterShow ? "show" : "hide"
                    }`}
                >
                  <div className="d-block d-md-none">
                    <button
                      className="closeMobilePopUp"
                      onClick={handleCloseMobilePopUp}
                    >
                      <img src={mediaCloseMobile} alt="close icon" />
                    </button>
                    <div className="mobilePopUpSectionHeader">
                      <div className="left">
                        <p>{SiteTrans.select_dates_txt[currentPage.locale.id]}</p>
                      </div>
                      <div className="right"></div>
                    </div>
                  </div>
                  <div className="mobilePopUpSection">
                    <div
                      className={`dateFilterWrapper pt-3 ${false ? "show" : "hide"
                        }`}
                    >
                      <div className="mediaCenterDaysWrapper">
                        <div className="col-md-12" onChange={getDays}>
                          {/* <span className='filter-timeline'></span> */}
                          <div className="row d-flex justify-content-start align-items-center g-3">
                            <div className="col-auto">
                              <DatePicker
                                maxDate={new Date()}
                                placeholderText={SiteTrans.select_dates_txt[currentPage.locale.id]}
                                selectsRange={true}
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => {
                                  setDateRange(update);
                                  getDateRangeFilter(update);
                                }}
                                isClearable={true}
                                calendarClassName="mediaCenterDatePicker"
                                customInput={<CustomInput />}
                                showMonthDropdown
                              />
                            </div>
                            <div className="col-auto">
                              <input
                                type="radio"
                                id="anyTime"
                                value="all"
                                className="option-input radio mediaDateRange radio-custom"
                                name="days"
                              />
                              <label
                                htmlFor="anyTime"
                                className="radio-custom-label"
                              >
                                {SiteTrans.any_time_txt[currentPage.locale.id]}
                              </label>
                            </div>
                            <div className="col-auto">
                              <input
                                type="radio"
                                id="thismonth"
                                value="thismonth"
                                className="option-input radio mediaDateRange radio-custom"
                                name="days"
                              />
                              <label
                                htmlFor="thismonth"
                                className="radio-custom-label"
                              >
                               {SiteTrans.this_month_txt[currentPage.locale.id]}
                              </label>
                            </div>
                            <div className="col-auto">
                              <input
                                type="radio"
                                id="lastmonth"
                                value="lastmonth"
                                className="option-input radio mediaDateRange radio-custom"
                                name="days"
                              />
                              <label
                                htmlFor="lastmonth"
                                className="radio-custom-label"
                              >
                                {SiteTrans.last_month_txt[currentPage.locale.id]}
                              </label>
                            </div>
                            <div className="col-auto">
                              <input
                                type="radio"
                                id="lastdays"
                                value="30"
                                className="option-input radio mediaDateRange radio-custom"
                                name="days"
                              />
                              <label
                                htmlFor="lastdays"
                                className="radio-custom-label"
                              >
                                {SiteTrans.last_30_days_txt[currentPage.locale.id]}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-block d-md-none showResultBtnWrapper">
                    {/* <div className='row'>
                      <div className='col-12'>
                        <hr />
                      </div>
                      <div className='col-12'>
                        <button className='showResultBtn' onClick={handleCloseMobilePopUp}>Show results  <img src={rightArrowWhite} alt="arrow icon" /></button>
                      </div>
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button id="toggleButton">Toggle Div</button>

        {/* FILTER BOX END*/}

        <div className="featured-news-list-wrapper">
          <div className="container">
            {featuredPosts.length > 0 ? (
              <div className="featured-news-list-container ">
                <h4 className="featured-articel-title font-xl">
                {SiteTrans.featured_articles_txt[currentPage.locale.id]}
                </h4>
                <div className="row">
                  {featuredPosts.map((data, index) => {
                    let content = data.node.content;
                    const wordsPerMinute = 200;
                    const wordCount = content.split(/\s+/).length;
                    const readingTimeMinutes = Math.ceil(
                      wordCount / wordsPerMinute
                    );

                    const dateObject = getFormatDate(
                      data.node.press_release_acf.publishedDate
                    );
                    const displayDate = format(dateObject, "MMMM d, yyyy");
                    console.log(displayDate,"date format");
                    var date = displayDate;
                    var arr1 = date.split(' ');
                    var arr2 = arr1[1].split(',');
                    var arr3 = arr1[2];
                    var month = arr1[0];

                    console.log(arr2,"arr2");
                    console.log(arr3,"arr3");
                    console.log(arr1[0],"arr1");
                    
                    // var newsandinsightsdate = translateDate(month,currentPage.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[currentPage.locale.id] +arr3;
                    if(currentPage.locale.id=="ar"){
                      var newsandinsightsdate = arr2[0]+' '+translateDate(month,currentPage.locale.id)+SiteTrans.comma_article_txt[currentPage.locale.id]+arr3;
                    }else{
                      var newsandinsightsdate = translateDate(month,currentPage.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[currentPage.locale.id]+arr3;
                    }
                    // const displayDate = data.node.date;

                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                        <div className="mb-4">
                          <NewsInsightsListingCards
                            primaryFontColor="#000"
                            secondaryFontColor="#000"
                            cardBg="#EEC643"
                            isDark={true}
                            lang={currentPage.locale.id}
                            featuredImage={
                              data.node.featuredImage
                                ? data.node.featuredImage.node
                                : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png"
                            }
                            shortTitle={data.node.press_release_acf.shortTitle}
                            shortDescription={
                              data.node.press_release_acf.summary
                            }
                            location={data.node.press_release_acf.location}
                            publishDate={newsandinsightsdate}
                            readTime={readingTimeMinutes}
                            parmalink={data.node.link}
                            categoryType={
                              data.node.newscategories.nodes[0]
                                ? data.node.newscategories.nodes[0].name
                                : null
                            }
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="newsListingWrapper">
          {visibleNews.length > 0 ? (
            <div className="all-news-list position-relative">
              <img
                className="news-list-brand-matrix position-absolute"
                src={newsAndInsightsPattern}
                alt="Jameel Motors"
              />
              <div className="container">
                <div className="featured-article-wrapper">
                  {featuredPosts.length === 0 ? (
                    <div className="row d-flex justify-content-between mb-4">
                      <div className="col-auto">
                        {searchKeyword ? (
                          <p>
                            {nonFeaturedPosts.length} {SiteTrans.matching_results_found_for[currentPage.locale.id]}{" "}
                            {searchKeyword}
                          </p>
                        ) : (
                          <p>
                            {nonFeaturedPosts.length} {SiteTrans.matching_results_found[currentPage.locale.id]}
                          </p>
                        )}
                      </div>
                      <div className="col-auto">
                        <select
                          className="form-control"
                          value={sortbyvalue}
                          onChange={handleSortBy}
                        >
                          <option selected>{SiteTrans.sort_by_txt[currentPage.locale.id]}</option>
                          <option value="newest">{SiteTrans.latest_txt[currentPage.locale.id]}</option>
                          <option value="oldest">{SiteTrans.oldest_txt[currentPage.locale.id]}</option>
                        </select>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                  {visibleNews.map((data, index) => {
                    let content = data.node.content;
                    const wordsPerMinute = 200;
                    const wordCount = content.split(/\s+/).length;
                    const readingTimeMinutes = Math.ceil(
                      wordCount / wordsPerMinute
                    );

                    const dateObject = getFormatDate(
                      data.node.press_release_acf.publishedDate
                    );

                    const displayDate = format(dateObject, "MMMM d, yyyy");
                    console.log(displayDate,"date format");
                    var date = displayDate;
                    var arr1 = date.split(' ');
                    var arr2 = arr1[1].split(',');
                    var arr3 = arr1[2];
                    var month = arr1[0];

                    console.log(arr2,"arr2");
                    console.log(arr3,"arr3");
                    console.log(arr1[0],"arr1");
                    
                    // var newsandinsightsdate = translateDate(month,currentPage.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[currentPage.locale.id] +arr3;
                    // const displayDate = data.node.date;
                    if(currentPage.locale.id=="ar"){
                      var newsandinsightsdate = arr2[0]+' '+translateDate(month,currentPage.locale.id)+SiteTrans.comma_article_txt[currentPage.locale.id]+arr3;
                    }else{
                      var newsandinsightsdate = translateDate(month,currentPage.locale.id)+' '+arr2[0]+ SiteTrans.comma_article_txt[currentPage.locale.id]+arr3;
                    }
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                        <div className="mb-4">
                          <NewsInsightsListingCards
                            primaryFontColor="#EEC643"
                            secondaryFontColor="#FFF"
                            cardBg="#28424D"
                            isDark={false}
                            lang={currentPage.locale.id}
                            featuredImage={
                              data.node.featuredImage
                                ? data.node.featuredImage.node
                                : "https://media.jameelmotors.com/wp-content/uploads/2023/10/placeholder-article.png"
                            }
                            shortTitle={data.node.press_release_acf.shortTitle}
                            shortDescription={
                              data.node.press_release_acf.summary
                            }
                            location={data.node.press_release_acf.location}
                            publishDate={newsandinsightsdate}
                            readTime={readingTimeMinutes}
                            parmalink={data.node.link}
                            categoryType={
                              data.node.newscategories.nodes[0]
                                ? data.node.newscategories.nodes[0].name
                                : null
                            }
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="row d-flex justify-content-center">
                  {showLoadMore ? (
                    <div className="col-auto">
                      <button
                        className="loadmore mediaCenterLoadMore  d-flex just"
                        onClick={loadMoreNews}
                      >
                       {SiteTrans.load_more_lable[currentPage.locale.id]}
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ) : featuredPosts.length > 0 ? null : (
            <div className="text-center font-weight-bold no-result-found">
              {SiteTrans.no_result_found_lable[currentPage.locale.id]}
            </div>
          )}
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12"></div>
          </div>
        </div>
      </div>

      <div id="mobilefilter" className="mobilefilterwrapper">
        <div className="row">
          <div className="col">sdfsd</div>
          <div className="col">sdfsd</div>
        </div>
        <div id="closeButton">
          <button>Close</button>
        </div>
      </div>
    </Layout>
  );
};

export default NewsListing;

export const pageQuery = graphql`
  query mainPage($id: String!, $langCode: ID!) {
    wpPage(id: { eq: $id }) {
      title
      content
      id
      link
      slug
      localizedWpmlUrl
      spotlightDetail {
        spotlightVideo {
          mediaItemUrl
          sourceUrl
          localFile {
            url
          }
        }
        spotlightImageOrSpotlightVideo
      }
      featuredImage {
        node {
          gatsbyImage(width: 1320, placeholder: BLURRED)
          altText
          sourceUrl
        }
      }
      locale {
        id
      }
      seo {
        opengraphTitle
        opengraphDescription
      }
      translated {
        id
        uri
        localizedWpmlUrl
        locale {
          id
          locale
        }
        publishStatus {
          status
        }
        slug
        title
        link
      }
    }
    allWpNews(
      filter: {
        locale: { id: { eq: $langCode } }
      },
      sort: { date: DESC }
    ) {
      edges {
        node {
          title
          link
          id
          content
          publishStatus {
            status
          }
          localizedWpmlUrl
          link
          slug
          date(formatString: "MMMM D, Y")
          featuredImage {
            node {
              sourceUrl
              gatsbyImage(width: 730, placeholder: BLURRED)
              altText
            }
          }
          locale {
            id
            locale
          }
          press_release_acf {
            publishedDate
            location
            featured
            shortTitle
            summary
          }
          translated {
            id
            localizedWpmlUrl
            locale {
              id
              locale
            }
            slug
            title
          }
          newscategories {
            nodes {
              name
              slug
            }
          }
          press_release_acf {
            summary
            shortTitle
            featured
            location
          }
        }
      }
    }
  }
`;
